import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import parentsModal from "models/parents.modal";
import tutorsModal from "models/tutors.modal";
import axios from "axios";
import Swal from "sweetalert2";
import Feedback from "views/Feedback";
import "./style.css";
import Parentmodel from "models/parents.modal";
import { toast } from "lib/helper";

const Commenction = () => {
  const params = useParams();

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [modal1, setModal1] = useState(false);

  const toggle1 = () => setModal1(!modal1);

  const [loading, setLoading] = useState(false);

  const [FeedbackList, setFeedbackList] = useState([]);
  const fetchFeddBack = async () => {
    // Dummy data for testing
    const dummyFeedback = [
      {
        id: 1,
        Notes: "Excellent teaching methodology. Student is progressing well.",
      },
      {
        id: 2,
        Notes: "The tutor is very patient and explains concepts clearly.",
      },
      {
        id: 3,
        Notes:
          "Good communication and regular updates on student's performance.",
      },
    ];
    setFeedbackList(dummyFeedback);
    // try {
    //   const response = await Parentmodel.getParentnote(
    //     params.id,
    //     "&type=feedback"
    //   );
    //   setFeedbackList(response?.data?.data);
    // } catch (error) {}
  };

  useEffect(() => {
    if (params.id != "") {
      fetchFeddBack();
    }
  }, []);

  const [Complaint, setComplaint] = useState();

  const handleSubmitComplaint = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = new FormData(e.currentTarget);
    form.append("ParentId", params.id);
    form.append("type", "complaint");

    try {
      const list = await Parentmodel.AddParentnote(form);

      toast("ADDED Complain", "success");
      fetchComplaint();
      toggle();
    } catch (error) {
      Swal.fire("Error", "There was a problem to add notes", "error");
    } finally {
      setLoading(false);
    }
  };

  const [ComplaintList, setComplaintList] = useState([]);
  const fetchComplaint = async () => {
    // Dummy data for testing
    const dummyComplaints = [
      {
        id: 1,
        Notes:
          "The tutor is not punctual for classes. Please address this issue.",
      },
      {
        id: 2,
        Notes:
          "Student is facing difficulties with math concepts. Need additional support.",
      },
      {
        id: 3,
        Notes:
          "Request for rescheduling the weekly test due to family emergency.",
      },
    ];
    setComplaintList(dummyComplaints);
    // try {
    //   const response = await Parentmodel.getParentnote(params.id,"&type=complaint");
    //   setComplaintList(response?.data?.data);
    // } catch (error) {
    //   console.log("error", error);
    // }
  };

  useEffect(() => {
    if (params.id != "") {
      fetchComplaint();
    }
  }, []);

  console.log("complain", ComplaintList);
  const [Feedback, setFeedback] = useState();
  const handleSubmitFeedback = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = new FormData(e.currentTarget);
    form.append("ParentId", params.id);
    form.append("type", "feedback");

    try {
      const list = await Parentmodel.AddParentnote(form);

      toast("ADDED Feedback", "success");
      fetchFeddBack();
      toggle1();
    } catch (error) {
      Swal.fire("Error", "There was a problem to add notes", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelFeedBack = async (delId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Parentmodel.deleteParentnote(delId)
          .then((res) => {
            Swal.fire("Deleted!", "The item has been deleted.", "success");
            fetchFeddBack();
          })
          .catch((error) => {
            console.error("Error deleting product:", error);
          });
      }
    });
  };

  const handleDelComplaint = async (delId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Parentmodel.deleteParentnote(delId)
          .then((res) => {
            Swal.fire("Deleted!", "The item has been deleted.", "success");
            fetchComplaint();
          })
          .catch((error) => {
            console.error("Error deleting product:", error);
          });
      }
    });
  };

  return (
    <div>
      <Container>
        <Row className="mt-4">
          <Col md="6">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <CardTitle tag="h5">Complaint</CardTitle>
                  <Button color="primary" onClick={toggle}>
                    + Add
                  </Button>
                </div>
                <Container>
                  {ComplaintList.length > 0 &&
                    ComplaintList?.map((item, index) => (
                      <Row
                        key={index}
                        className="my-2 align-items-center feedback-item"
                      >
                        <Col xs="1">
                          <span>{index + 1}</span>
                        </Col>
                        <Col xs="9">
                          <span>{item?.Notes}</span>
                        </Col>
                        <Col xs="2" className="text-right">
                          <Button
                            color="danger"
                            onClick={() => handleDelComplaint(item.id)}
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </Col>
                      </Row>
                    ))}
                </Container>
              </CardBody>
            </Card>
          </Col>
          <Col md="6">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <CardTitle tag="h5">Feedback</CardTitle>
                  <Button color="primary" onClick={toggle1}>
                    + Add
                  </Button>
                </div>
                <Container>
                  {FeedbackList.length > 0 &&
                    FeedbackList?.map((item, index) => (
                      <Row
                        key={index}
                        className="my-2 align-items-center feedback-item"
                      >
                        <Col xs="1">
                          <span>{index + 1}</span>
                        </Col>
                        <Col xs="9">
                          <span>{item.Notes}</span>
                        </Col>
                        <Col xs="2" className="text-right">
                          <Button
                            color="danger"
                            onClick={() => handleDelFeedBack(item.id)}
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </Col>
                      </Row>
                    ))}
                </Container>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <h4>Add Complaint</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmitComplaint}>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="exampleEmail">Complaint</Label>
                    <Input
                      name="Notes"
                      id="forType"
                      type="textarea"
                      onChange={(e) => setComplaint(e.target.value)}
                      value={Complaint}
                      placeholder="Enter Complaint"
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>

                <Button
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal1} toggle={toggle1}>
          <ModalHeader toggle={toggle1}>
            <h4>Add Feedback</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmitFeedback}>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="exampleEmail">Feedback</Label>
                    <Input
                      name="Notes"
                      id="forType"
                      type="textarea"
                      onChange={(e) => setFeedback(e.target.value)}
                      value={Feedback}
                      placeholder="Enter Feedback"
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggle1}>
                  Cancel
                </Button>

                <Button
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </Container>
    </div>
  );
};

export default Commenction;
